/*
 * TurnReportEdit Messages
 *
 * This contains all the text for the TurnReportEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  editTurnReportHeader: {
    id: 'app.containers.TurnReportEdit.editTurnReportHeader',
    defaultMessage: 'Edit turn report',
  },
  attendance: {
    id: 'app.containers.TurnReportEdit.attendance',
    defaultMessage: 'Attendance',
  },
  duration: {
    id: 'app.containers.TurnReportEdit.duration',
    defaultMessage: 'Duration',
  },
  results: {
    id: 'app.containers.TurnReportEdit.results',
    defaultMessage: 'Results',
  },
  editSuccess: {
    id: 'app.containers.TurnReportEdit.editSuccess',
    defaultMessage: 'Shift report has been successfully updated',
  },
  editFailure: {
    id: 'app.containers.TurnReportEdit.editFailure',
    defaultMessage: 'Updating the shift report failed',
  },
  closeTurnReportTitle: {
    id: 'app.containers.TurnReportEdit.closeTurnReportTitle',
    defaultMessage: 'Hand this report in?',
  },
  closeTurnReportText: {
    id: 'app.containers.TurnReportEdit.closeTurnReportText',
    defaultMessage:
      "After closing the report you won't be able to make any more adjustments to it.",
  },
  closeTurnReportConfirm: {
    id: 'app.containers.TurnReportEdit.closeTurnReportConfirm',
    defaultMessage: 'Yes, close report',
  },
  closeTurnReportCancel: {
    id: 'app.containers.TurnReportEdit.closeTurnReportCancel',
    defaultMessage: 'No, keep report open',
  },
});
